import { createAction, props } from '@ngrx/store';
import { UpdateAlarmStatusRequest } from '../../models/requests/update-alarm-status.request';
import { CreatePotentialCauseRequest } from '../../models/requests/create-potential-cause-request';
import { UpdatePotentialCauseRequest } from '../../models/requests/update-potential-cause-request';
import { PotentialCause } from '../../models/potential-cause.model';

// Load actions
export const loadPotentialCause = createAction(
  '[potentialCause] Load Potential Cause',
  props<{ ruleUid: string | undefined }>()
);
export const loadPotentialCauseSuccess = createAction(
  '[potentialCause] Load Potential Cause Success',
  props<{ potentialCause: PotentialCause[] }>()
);
export const loadPotentialCauseFailure = createAction(
  '[potentialCause] Load Potential Cause Failure',
  props<{ error: any }>()
);

// Delete actions
export const deleteMultiplePotentialCauses = createAction(
  '[potentialCause] Delete Multiple Potential Causes',
  props<{ uids: string[] }>()
);
export const deleteMultiplePotentialCausesSuccess = createAction(
  '[potentialCause] Delete Multiple Potential Causes Success',
  props<{ uids: string[] }>()
);
export const deleteMultiplePotentialCausesFailure = createAction(
  '[potentialCause] Delete Multiple Potential Causes Failure',
  props<{ error: any }>()
);

// Batch operations
export const createMultiplePotentialCauses = createAction(
  '[potentialCause] Create Multiple Potential Causes',
  props<{ requests: CreatePotentialCauseRequest[] }>()
);
export const createMultiplePotentialCausesSuccess = createAction(
  '[potentialCause] Create Multiple Potential Causes Success',
  props<{ potentialCauses: PotentialCause[] }>()
);
export const createMultiplePotentialCausesFailure = createAction(
  '[potentialCause] Create Multiple Potential Causes Failure',
  props<{ error: any }>()
);

export const updateMultiplePotentialCauses = createAction(
  '[potentialCause] Update Multiple Potential Causes',
  props<{ requests: UpdatePotentialCauseRequest[] }>()
);
export const updateMultiplePotentialCausesSuccess = createAction(
  '[potentialCause] Update Multiple Potential Causes Success',
  props<{ potentialCauses: PotentialCause[] }>()
);
export const updateMultiplePotentialCausesFailure = createAction(
  '[potentialCause] Update Multiple Potential Causes Failure',
  props<{ error: any }>()
);
